/**
 * This type is purely used by the client, i.e. was not part of the REST contract definition
 */
export enum TournamentStatus {
  NONE = 'none',
  UPCOMING = 'upcoming',
  RUNNING = 'running',
  FINISHED = 'finished',
}
